import { connect } from 'react-redux';
import Footer from './footer';


const mapStateToProps = state => ({
  config: state.authentication.config,
});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);



// WEBPACK FOOTER //
// ./src/app/footer/footer.container.js